import mod from "-!../../vue-loader/lib/index.js??vue-loader-options!./Monaco.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../vue-loader/lib/index.js??vue-loader-options!./Monaco.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-monaco-editor/src/Monaco.vue?vue&type=script&lang=js&
// module id = ./node_modules/vue-monaco-editor/src/Monaco.vue?vue&type=script&lang=js&
// module chunks = 2